import { render, staticRenderFns } from "./VerifyAccess.vue?vue&type=template&id=deccd70e"
import script from "./VerifyAccess.vue?vue&type=script&lang=js"
export * from "./VerifyAccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports